import type { FaireProductEntity } from "../../entity_types/product";

export const p_4n6nau4ujx: FaireProductEntity = {
  token: "p_4n6nau4ujx",
  type: "product",
  name: "Ojai Lavender - Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/5b6dcf068d13860050d90e18e7898f5f866ece12838c17a83f7825cb249ece9e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dddc3f4f35347914cabab97bfad4dba44ef64b2b55db3e3bfb012602c480e10a.jpeg",
    "https://cdn.faire.com/fastly/eac0cd11953762d4f3e428c3dfb5499350b58d1ac205acc42aa9e582f1d01f2f.jpeg",
    "https://cdn.faire.com/fastly/be83086637055d198072996a2ce0bdc87fff96d78ae5cd50c79a3d9c1dce9448.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/41db24fd9063c264330da38383dae63613a26b7f136eac29b3b925821c80ec91.jpeg",
    "https://cdn.faire.com/fastly/9d0bd272bd3218e678e2ad4d572062a04d096c083b603c5391706273149cb761.jpeg",
  ],
  priceDollars: 5,
  description:
    'Sun-drenched fields, orange groves and lavender farms, jagged mountains washed in a rosy, sunset glow. Pixie tangerine, lavender, mint.\n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:48.049Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
